import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Only handle authentication failures, not other 401/403 errors
    if (error.response?.status === 401 || 
        (error.response?.status === 403 && error.response?.data?.error?.includes('token'))) {
      
      // Only redirect if we're not already on auth pages
      const currentPath = window.location.pathname;
      const isAuthPage = currentPath === '/login' || currentPath === '/register' || currentPath === '/forgot-password';
      
      if (!isAuthPage) {
        // Clear authentication data
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        
        // Clear all feed-related data
        localStorage.removeItem('feedType');
        sessionStorage.removeItem('feedScrollPosition_foryou');
        sessionStorage.removeItem('feedScrollPosition_following');
        sessionStorage.removeItem('previousLocation');
        sessionStorage.removeItem('historyStack');
        
        // Clear all scroll positions
        const keys = Object.keys(sessionStorage);
        keys.forEach(key => {
          if (key.startsWith('scroll-') || key.startsWith('scrollPos-')) {
            sessionStorage.removeItem(key);
          }
        });
        
        // Dispatch logout event to notify components
        window.dispatchEvent(new CustomEvent('userLogout'));
        
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
